import "./App.scss";
import "./styles/images.scss";
import Home from "./views/Home";
import { getFirestore } from "firebase/firestore/lite";
import { Route, Routes, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Blog from "./views/Blog";
import Article from "./views/Article";
import About from "./views/About";
import Login from "./views/Login";
import LessonBooking from "./views/LessonBooking";
import BookingAdmin from "./views/BookingAdmin";
import { ThemeProvider } from "@mui/material";
import { customTheme } from "./theme";
import { HelmetProvider } from "react-helmet-async";
import BackToTopButton from "./components/BackToTopButton";
import Cms from "./views/Cms";
import { app } from "./firebaseConfig";
import NotFound from "./views/NotFound";
import ProtectedRoute from "./components/Protectedroute";

function App() {
  const location = useLocation();
  const db = getFirestore(app);

  return (
    <>
      <ToastContainer />
      <HelmetProvider>
        <ThemeProvider theme={customTheme}>
          {(location.pathname !== "/cms" && location.pathname !== "/booking-admin") && <BackToTopButton />}
          <Routes>
          <Route path="/" element={<Home db={db} />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<Article />} />
          <Route path="/chi-sono" element={<About />} />
          <Route path="/prenotazioni" element={<LessonBooking />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/cms"
            element={
              <ProtectedRoute>
                <Cms db={db} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/booking-admin"
            element={
              <ProtectedRoute>
                <BookingAdmin />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
          </Routes>
        </ThemeProvider>
      </HelmetProvider>
    </>
  );
}

export default App;
